// document.addEventListener("turbo:load", () => {
//   ReactRailsUJS.mountComponents();
// });

// let markers = {};
let map;

function initMapShow() {
  var mapElement = document.getElementById("map_show");

  // "map_show"要素が存在しない場合は、関数を早期に終了します。
  if (!mapElement) {
    return;
  }

  const directionsService = new google.maps.DirectionsService();
  const directionsRenderer = new google.maps.DirectionsRenderer();
  // const directionsRenderer = new google.maps.DirectionsRenderer({ preserveViewport: true });
  const mapOptions = {
    zoom: 5,
    // center: { lat: 35.681236, lng: 139.767125 },
    // center: { lat: current_lat, lng: current_lng },
  };

  map = new google.maps.Map(document.getElementById("map_show"), mapOptions);
  directionsRenderer.setMap(map);

  // 出発地と目的地の座標を設定  
  var startPoint = new google.maps.LatLng(start_lat, start_lng);
  var goalPoint = new google.maps.LatLng(goal_lat, goal_lng);

  const waypoints = [];

  for (let i = 0; i < restPoints.length; i++) {
    var latLng = new google.maps.LatLng(restPoints[i].lat, restPoints[i].lng);
    waypoints.push({
      location: latLng,
      stopover: true,
    });
  }

  // 経路のリクエスト
  const request = {
      origin: startPoint,
      destination: goalPoint,
      waypoints: waypoints,
      avoidFerries: avoidFerrie,
      avoidHighways: avoidHighways,
      avoidTolls: avoidTolls,
      // optimizeWaypoints: true,
      travelMode: "DRIVING",
    };

  // ���路を取得し、地図上に描画
  directionsService.route(request, function(result, status) {
    if (status == google.maps.DirectionsStatus.OK) {
      directionsRenderer.setDirections(result);

      // 経路描画後にユーザーのマーカーを更新
      // updateUserMarkers();
    }
  });
}

function initMap() {
  // 地図のインスタンスを生成
  const map = new google.maps.Map(document.getElementById('map'), {
    center: {lat: 35.710063, lng: 139.810700},
    zoom: 5
  });

  // 経路案内のためのインスタンスを生成
  const directionsService = new google.maps.DirectionsService();
  const directionsRenderer = new google.maps.DirectionsRenderer();

  // 経路描画の設定
  directionsRenderer.setMap(map);

  // 出発地と目的地の座標を設定
  var origin = new google.maps.LatLng(start_lat, start_lng);
  var destination = new google.maps.LatLng(goal_lat, goal_lng);

  // 経路のリクエスト
  var request = {
    origin: origin,
    destination: destination,
    avoidFerries: avoidFerrie,
    avoidHighways: avoidHighways,
    avoidTolls: avoidTolls,
    travelMode: google.maps.TravelMode.DRIVING
  };

  // 経路を取得し、地図上に描画
  directionsService.route(request, function(result, status) {
    if (status == google.maps.DirectionsStatus.OK) {
      directionsRenderer.setDirections(result);
    }
  });

  const form = document.querySelector("form"); // フォーム要素を取得
  const startPointInput = document.getElementById("start_point");
  const goalPointInput = document.getElementById("goal_point");
  const restPointInputs = document.getElementsByClassName("rest_point");
  const autocompletes = [];

  const onChangeHandler = function () {
    const startPoint = document.getElementById("start_point");
    const goalPoint = document.getElementById("goal_point");
  
    // 出発地と目的地の入力フィールドが空でないことを確認
    if (startPoint.value && goalPoint.value) {
      calculateAndDisplayRoute(directionsService, directionsRenderer);
    }
  };

  const startPoint = document.getElementById("start_point");
  const goalPoint = document.getElementById("goal_point");
  
  document.getElementById("start_point").addEventListener("change", onChangeHandler);
  document.getElementById("goal_point").addEventListener("change", onChangeHandler);
  
  // 経由地の入力フィールドにイベントリスナを追加
  // restPointsに現在の休憩地を追加
  const restPoints = Array.from(document.getElementsByClassName("rest_point"));
  restPoints.forEach((restPoint) => {
    restPoint.addEventListener("change", onChangeHandler);
  });

  // チェックボックスのイベントリスナを追加
  document.getElementById("highways_checkbox").addEventListener("change", onChangeHandler);
  document.getElementById("tolls_checkbox").addEventListener("change", onChangeHandler);
  document.getElementById("ferries_checkbox").addEventListener("change", onChangeHandler);

}

// window.initMap = initMap;

// document.addEventListener('turbolinks:load', function() {
//   initMapShow();
// });

$(function() {
  $(document).on('click', '.touring-table-member-button', function() {
    $(".touring-table.member-list").toggle();
  });
});

// googleナビの表示
$(function(){
  $('.google-nav').on('click', function(){
    let url = `https://www.google.com/maps/dir/${start_point}`;
    rest_points.forEach(point => {
      url += `/${point}`;
    });
    url += `/${goal_point}`;
    window.open(url, "_blank");
  });
})

// スポットマップの営業時間の詳細
document.addEventListener("DOMContentLoaded", function() {
  const timeToggle = document.querySelector(".time");
  const timeDetails = document.querySelector(".time-details");
  
  if (timeToggle && timeDetails) {
    timeToggle.addEventListener("click", function () {
      timeDetails.classList.toggle("hidden");
    });
  }
});

// let photos = [];



// スポットマップのマップ表示
function initMapSpotMap() {
  let markers = []; // ← ここで初期化

  const input = document.getElementById('spot_name');

  const mapElement = document.getElementById('map3');

  // "map3"要素が存在しない場合は、関数を早期に終了します。
  if (!mapElement) {
    return;
  }

  const map = new google.maps.Map(mapElement, {
    center: { lat: lat, lng: lng },
    // center: { lat: 35.68, lng: 139.76 },
    zoom: 16,
    mapId: process.env.REACT_APP_GOOGLE_MAPS_ID
  });

  const marker = new google.maps.marker.AdvancedMarkerElement({
    map,
    // position: place.geometry.location
    // position: { lat: 35.68, lng: 139.76 }
    position: { lat: lat, lng: lng }
  });
  markers.push(marker);

  // console.log("Lat:", lat);
  // console.log("Lng:", lng);

  const spotNameInput = document.getElementById("spot_name");

  // IME変換中はAPI呼び出しを抑制し、変換確定後に検索をトリガーする
  let isComposing = false;

  spotNameInput.addEventListener('compositionstart', () => {
    isComposing = true;
  }, true);

  spotNameInput.addEventListener('compositionend', () => {
    isComposing = false;
    // blur/focusでGoogle Autocompleteに確定後の値で検索をトリガーする
    setTimeout(() => {
      spotNameInput.blur();
      spotNameInput.focus();
    }, 10);
  }, true);

  spotNameInput.addEventListener('input', (e) => {
    if (isComposing) e.stopImmediatePropagation();
  }, true);

  const autocomplete = new google.maps.places.Autocomplete(spotNameInput, {
    fields: [
      "geometry",
      "name",
      "vicinity",
      "formatted_phone_number",
      "website",
      "business_status",
      "photos",
      "opening_hours"
    ]
  });

  // place選択イベント
  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();

    if (!place.geometry) return;

    // 入力欄に住所ではなく地名を表示する
    spotNameInput.value = place.name || "";

    // 既存マーカー削除
    markers.forEach(m => m.map = null);
    markers.length = 0;

    console.log("Lat:", place.geometry.location.lat());
    console.log("Lng:", place.geometry.location.lng());

    // 新マーカー
    const marker = new google.maps.marker.AdvancedMarkerElement({
      map,
      position: place.geometry.location
    });
    markers.push(marker);

    // ビューポート調整
    const bounds = new google.maps.LatLngBounds();
    if (place.geometry.viewport) {
      bounds.union(place.geometry.viewport);
    } else {
      bounds.extend(place.geometry.location);
    }
    map.fitBounds(bounds);

    // 各種UI更新
    document.querySelector('.address').value = place.vicinity || "";
    document.getElementById("hidden-address").value = place.vicinity || "";

    let statusLabel = "";
    if (place.business_status === "OPERATIONAL") statusLabel = "営業";
    if (place.business_status === "CLOSED_TEMPORARILY") statusLabel = "臨時休業";
    if (place.business_status === "CLOSED_PERMANENTLY") statusLabel = "閉業";
    document.querySelector('.status').value = statusLabel;
    document.getElementById("hidden-status").value = statusLabel;

    if (place.opening_hours?.weekday_text) {
      const weekdayText = place.opening_hours.weekday_text;
      const timeTextarea = document.querySelector('.time-details-form');
      if (timeTextarea) timeTextarea.value = weekdayText.join('\n');
      document.getElementById("hidden-time").value = weekdayText.join("\n");
      document.querySelector('.time').style.display = 'block';
    } else {
      document.querySelector('.time').style.display = 'none';
    }

    const call = place.formatted_phone_number || "";
    const callForm = document.querySelector('.call');
    if (call) {
      callForm.classList.remove("no-display");
      callForm.value = call;
      document.getElementById("hidden-call").value = call;
    } else {
      callForm.classList.add("no-display");
    }

    const url = place.website || "";
    const urlDetailsDiv = document.querySelector('.url-details');
    const urlInput = document.querySelector('.url');
    const urlLink = document.querySelector('.url-details a');
    if (url) {
      urlDetailsDiv.classList.remove("no-display");
      urlInput.value = url;
      urlLink.setAttribute("href", url);
      document.getElementById("hidden-url").value = url;
    } else {
      urlDetailsDiv.classList.add("no-display");
    }

    const photoContainer = document.getElementById('photo-container');
    photoContainer.innerHTML = "";
    if (place.photos?.length) {
      place.photos.forEach(photo => {
        const photoUrl = photo.getUrl({ maxWidth: 400 });
        const img = document.createElement("img");
        img.src = photoUrl;
        img.className = "image-post-btn-img";
        photoContainer.appendChild(img);

        const hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "spot_map[img_urls][]";
        hidden.value = photoUrl;
        document.querySelector("form").appendChild(hidden);
      });
    }

    document.getElementById("hidden-lat").value = place.geometry.location.lat();
    document.getElementById("hidden-lng").value = place.geometry.location.lng();
  });
}

// window.initMapSpotMap = initMapSpotMap;

// ⭐️spotmapでReviewをポストした後に地図が消える問題を解決するため、Turbolinksによってページがロードされるたびに、「initMapSpotMap()」が実行されるようにしている。SMI/SMD/SMNで「google is not defined」のエラーが出てしまうのはしょうがない。
// 2026/5/3、エラーが解消された
document.addEventListener('turbolinks:load', function() {
  if (typeof google !== 'undefined') {
    initMapSpotMap();
  }
});

function initAllMaps() {
  console.log("Google Maps API loaded!");
  // if (document.getElementById('map')) {
  //   initMap();
  // }

  if (document.getElementById('map_show')) {
    initMapShow();
  }

  if (document.getElementById('map3')) {
    initMapSpotMap();
  }
}


// 「window.addEventListener('load', initAllMaps);」がないと、TGDから別のTGDへ遷移する際にマップが表示されなくなる。
window.addEventListener('load', initAllMaps);

window.initAllMaps = initAllMaps;



document.addEventListener("DOMContentLoaded", function() {
  var modal = document.getElementById('terms-modal');
  var link = document.getElementById('terms-link');
  var close = document.getElementById('close');
  var closeButton = document.getElementById('close-button');
  
  var modal_p = document.getElementById('terms-modal_p');
  var link_p = document.getElementById('terms-link_p');
  var close_p = document.getElementById('close_p');
  var closeButton_p = document.getElementById('close-button_p');
  // 利用規約のモーダル表示
  // console.log("terms-link",link);
  if(link) {
    link.onclick = function() {
      modal.style.display = "block";
    }
  }

  if(close) {
    close.onclick = function() {
      modal.style.display = "none";
    }
  }

  if(closeButton) {
    closeButton.onclick = function() {
      modal.style.display = "none";
    }
  }

  // プライバシーポリシーのモーダル表示
  if(link_p) {
    link_p.onclick = function() {
      modal_p.style.display = "block";
    }
  }

  if(close_p) {
    close_p.onclick = function() {
      modal_p.style.display = "none";
    }
  }

  if(closeButton_p) {
    closeButton_p.onclick = function() {
      modal_p.style.display = "none";
    }
  }

  window.addEventListener('click', function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  });

  window.addEventListener('click', function(event) {
    if (event.target == modal_p) {
      modal_p.style.display = "none";
    }
  });

  if (location.pathname == '/users/sign_up') {
    document.getElementById('user_terms_agreement').addEventListener('change', function(e) {
      var registrationButton = document.getElementById('registration_button');
  
      // ボタンの有効・無効を切り替え
      registrationButton.disabled = !e.target.checked;
      // guestLoginButton.disabled = !e.target.checked;
  
      // 'disabled'クラスの追加と削除
      if (!e.target.checked) {
        registrationButton.classList.add('disabled');
      } else {
        registrationButton.classList.remove('disabled');
      }
    });
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === "childList") {
        attachEventListener();
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  function attachEventListener() {
    var userTermsAgreement = document.getElementById('user_terms_agreement');
  
    if (userTermsAgreement) {
      userTermsAgreement.addEventListener('change', function(e) {
        var registrationButton = document.getElementById('registration_button');

        registrationButton.disabled = !e.target.checked;  
        if (!e.target.checked) {
          registrationButton.classList.add('disabled');
        } else {
          registrationButton.classList.remove('disabled');
        }
      });
    }
  }

  attachEventListener();
});

// document.addEventListener('DOMContentLoaded', function() {
//   attachEventListener();
// });

// 空chatの送信防止
document.addEventListener("DOMContentLoaded", function(){
  if (/^\/touring_groups\/\d+$/.test(location.pathname)) {

    var sentenceInput = document.getElementById('sentence');
    var sendButton = document.getElementById('send');
    
    if (sendButton) {
      sendButton.disabled = true; // 要素が存在する場合のみ設定
    }
    // sendButton.disabled = true;

    if (sentenceInput) {
      sentenceInput.addEventListener('input', function() {
        if(sentenceInput.value === ''){
          sendButton.disabled = true;
          sendButton.classList.add('disabled');
        } else {
          sendButton.disabled = false;
          sendButton.classList.remove('disabled');
        }
      });
    }

    if (document.getElementById('send-form')) {
      document.getElementById('send-form').addEventListener('submit', function(e){
        if(sentenceInput.value === ''){
          e.preventDefault();
          alert('メッセージを入力してください。');
        }
        sendButton.disabled = true;
        sendButton.classList.add('disabled');
      });
    }

  }
});

document.addEventListener("DOMContentLoaded", (event) => {

  if (location.pathname == '/spot_maps/new') {
    let checkboxes = document.getElementsByClassName("category_each");
    let button = document.getElementById('sm_registration');
  
    // チェックボックス全体を確認し、少なくとも1つがチェックされているかどうかをチェックします
    let updateButtonStatus = function() {
      let isChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
      button.disabled = !isChecked;
      if (isChecked) {
        button.classList.remove('disabled');
      } else {
        button.classList.add('disabled');
      }
    };
  
    // 初期状態のボタンの状態を更新します
    updateButtonStatus();
  
    // 各チェックボックスに対してイベントリスナーを追加します
    for (let i = 0; i < checkboxes.length; i++) {
      checkboxes[i].addEventListener('change', updateButtonStatus);
    }
  }  
});

// headerのBackボタンの実装
// document.addEventListener("turbolinks:load", function(){
//   const backButton = document.querySelector(".button-back");

//   if (backButton) {
//     backButton.addEventListener("click", function(e){
//       e.preventDefault();
//       window.history.back();
//     });
//   }
// });

// 画面遷移前に現在のURLを保存
document.addEventListener("turbolinks:before-visit", function(){
  localStorage.setItem('previousUrl', window.location.href);
});

// Backボタンがクリックされたときに、保存したURLに遷移
document.addEventListener("turbolinks:load", function(){
  const backButton = document.querySelector(".button-back");

  if (backButton) {
    backButton.addEventListener("click", function(e){
      e.preventDefault();
      const previousUrl = localStorage.getItem('previousUrl');
      if (previousUrl) {
        Turbolinks.visit(previousUrl, { action: 'replace' });
      }
    });
  }
});

window.addEventListener("DOMContentLoaded", function() {
  // Check if we're on the /users/edit page.
  if (window.location.pathname === "/users/edit") {
    var current_password = document.querySelector('input[name="user[current_password]"]');
    var submit_button = document.querySelector('.button-login');

    // If either of the elements don't exist on the page, stop executing the code.
    if (!current_password || !submit_button) {
      return;
    }

    // Check the initial state.
    if (current_password.value === '') {
      if (submit_button) {
        submit_button.disabled = true;
      }
    }

    // Monitor changes in the password input field.
    current_password.addEventListener('input', function() {
      if (current_password.value === '') {
        submit_button.disabled = true;
      } else {
        submit_button.disabled = false;
      }
    });
  }
});

// 画像投稿機能（画像登録失敗後でも、画像名が残る）
document.addEventListener("DOMContentLoaded", function(){
  if (location.pathname == '/users/edit' 
  || location.pathname == '/users/sign_up'
  || location.pathname == '/my_cars/new'
  || location.pathname.startsWith('/my_cars') && location.pathname.endsWith('/edit')) {
    const realFileBtn = document.getElementById("real-file");
    const imagePreview = document.getElementById("image-preview");

    imagePreview.addEventListener("click", function() {
      realFileBtn.click();
    });

    realFileBtn.addEventListener("change", function() {
      const file = this.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = function(e) {
          imagePreview.src = e.target.result;
        }
        reader.readAsDataURL(file);
      }
    });

    const realFileBtn2 = document.getElementById("real-file2");
    const imagePreview2 = document.getElementById("image-preview2");

    if (imagePreview2) {
      imagePreview2.addEventListener("click", function() {
        realFileBtn2.click();
      });
    }

    if (realFileBtn2) {
      realFileBtn2.addEventListener("change", function() {
        const file2 = this.files[0];
        if (file2) {
          const reader2 = new FileReader();
          reader2.onload = function(e) {
            imagePreview2.src = e.target.result;
          }
          reader2.readAsDataURL(file2);
        }
      });
    }


    const realFileBtn3 = document.getElementById("real-file3");
    const imagePreview3 = document.getElementById("image-preview3");

    if (imagePreview3) {
      imagePreview3.addEventListener("click", function() {
        realFileBtn3.click();
      });
    }

    if (realFileBtn3) {
      realFileBtn3.addEventListener("change", function() {
      const file3 = this.files[0];
        if (file3) {
          const reader3 = new FileReader();
          reader3.onload = function(e) {
            imagePreview3.src = e.target.result;
          }
          reader3.readAsDataURL(file3);
        }
      });
    }
  }
});

document.addEventListener("DOMContentLoaded", function(){
  if (/^\/spot_maps\/\d+$/.test(location.pathname) || /^\/users\/\d+$/.test(location.pathname) || /^\/my_cars\/\d+$/.test(location.pathname)) {
    new LuminousGallery(document.querySelectorAll(".grid-gallery"));
  }
});